import {TOAST_MESSAGE, TOAST_CLEAR} from '../actions/toast';

const INITIAL_STATE = {message: '', open: false};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case TOAST_MESSAGE:
            return {...state, message: action.payload, open: true};
        case TOAST_CLEAR:
            return {...state, message: '', open: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/reducers/toast.js